import { atom, getEcosystem, } from "@zedux/react";

export interface IShareContentState {
    name: string
    mimeType: string
    size: number
    dataBase64: string
}

export const EmptyShareContent = Symbol("EmptyShareContent");
export type ISharedAtomState = IShareContentState | typeof EmptyShareContent

export const shareContentAtom = atom<ISharedAtomState>("share_content", EmptyShareContent)

export const setShareContent = ({ name, mimeType, size, dataBase64 }: IShareContentState) => {
    try {
        const ecosystem = getEcosystem('@@global')
        if (!ecosystem) {
            return
        }

        const shareContentAtomInstance = ecosystem.getInstance(shareContentAtom)
        if (!shareContentAtomInstance) {
            return
        }

        shareContentAtomInstance.setState({ name, mimeType, size, dataBase64 })
    } catch (error) {
        console.error("Error setting share content:", error)
    }
}
